"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _isNil = _interopRequireDefault(require("../object/isNil"));

var _isNumber = _interopRequireDefault(require("./isNumber"));

var isNumeric = function isNumeric(valueToTest) {
  return !(0, _isNil["default"])(valueToTest) && (0, _isNumber["default"])(parseFloat(valueToTest));
};

var _default = isNumeric;
exports["default"] = _default;